import { createSelector } from 'reselect';
import { requestFailed } from 'redux-request-state/util/requestStateCheckers';
import { getLatestArtifact } from 'redux-request-state/selectors/artifactSelectors';
import { FETCH_EMBED_CODE_REQUEST } from 'web-interactives-dashboard-ui/utils/requestStateKeys';
export const getEmbedCode = state => state.embedCode;
export const getFetchEmbedRequestStatus = state => getLatestArtifact(state, {
  requestKey: FETCH_EMBED_CODE_REQUEST
});
export const getFetchEmbedRequestFailed = createSelector(getFetchEmbedRequestStatus, fetchStatus => requestFailed(fetchStatus));